// userSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../services/AxiosInstance";

// Create an async thunk to fetch user data
export const fetchuserData = createAsyncThunk(
  "user/fetchuserData",
  async () => {
    try {
      const response = await axiosInstance.get("admin/user/view");
      return response.data.data;
    } catch (error) {
      throw error;
    }
  }
);

const userSlice = createSlice({
  name: "user",
  initialState: {
    data: [],
    userCount: 0,
    loading: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchuserData.pending, (state) => {
        state.loading = "loading";
      })
      .addCase(fetchuserData.fulfilled, (state, action) => {
        state.loading = "succeeded";
        state.data = action.payload;
        state.userCount = action.payload.length;
      })
      .addCase(fetchuserData.rejected, (state, action) => {
        state.loading = "failed";
        state.error = action.error.message;
      });
  },
});

export default userSlice.reducer;
